/* eslint-disable no-mixed-spaces-and-tabs */
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import {
	getOrdersGroupsListRequest,
	getOrdersPlanningsListRequest,
	getVeerouteConfigsRequest,
} from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME, VEEROUTE_URL } from '../../api/constants';
import {
	GET_ORDERS_PLANNINGS_LIST,
	setIsOrdersPlanningsListLoadingAction,
	setPaginationAction,
	setOrdersPlanningsListAction,
	setIsGroupsLoadingAction,
	setGroupsAction,
	GET_GROUPS,
	setIsConfigsLoadingAction,
	setConfigsAction,
	GET_CONFIGS,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getOrdersPlanningsListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsOrdersPlanningsListLoadingAction(true));
		}

		const { data, meta, message, toast } = yield call(getOrdersPlanningsListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setOrdersPlanningsListAction(
					data?.map(order => ({
						...order,
						link: order.experiment_key
							? {
									text: 'Перейти',
									target: '_blank',
									url: `${VEEROUTE_URL}/experiments/${order.experiment_key}`,
							  }
							: null,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsOrdersPlanningsListLoadingAction(false));
	}
}

export function* getGroupsSaga() {
	try {
		yield put(setIsGroupsLoadingAction(true));

		const { data, message, toast } = yield call(getOrdersGroupsListRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setGroupsAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsGroupsLoadingAction(false));
	}
}

export function* getConfigsSaga() {
	try {
		yield put(setIsConfigsLoadingAction(true));

		const { data, message, toast } = yield call(getVeerouteConfigsRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setConfigsAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsConfigsLoadingAction(false));
	}
}

export default function* ordersPlanningsContainerSaga() {
	yield takeEvery(GET_ORDERS_PLANNINGS_LIST, getOrdersPlanningsListSaga);
	yield takeEvery(GET_GROUPS, getGroupsSaga);
	yield takeEvery(GET_CONFIGS, getConfigsSaga);
}
